import { mapGetters } from 'vuex'

export default {
  computed: mapGetters('subscription', ['isOnFreePlan']),

  created () {
    this.$store.dispatch('subscription/checkSubscriptionName')
  },
}
